export default "/images/ec9cda7cc54862226413dda104e86c26.avif";